import { observable } from "mobx";
import { Type } from "class-transformer";
import OriginalPayGatePaymentResponse from "./originalPayGatePaymentResponse";
import OriginalTransferPaymentResponse from "./originalTransferPaymentResponse";
import PaymentType from "./paymentType";
import SourceType from "./sourceType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class OutgoingTransferOriginalPaymentResponse {
  @observable
  sourceType!: SourceType;

  @observable
  paymentType?: PaymentType;

  @observable
  @Type(() => OriginalPayGatePaymentResponse)
  originalPayGatePayment?: OriginalPayGatePaymentResponse;

  @observable
  @Type(() => OriginalTransferPaymentResponse)
  originalTransferPayment?: OriginalTransferPaymentResponse;
}
